module.exports = global["$"] = require("-!/rails/node_modules/expose-loader/index.js?jQuery!./jquery.js");